import APIV5 from '~/models/api';
import { wfGetJobDescription, wfMap } from '~/scripts/services/model/workflow';

export default class ModalWfHistoryController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} jobs
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$injector,
		$scope,
		$timeout,
		$translate,
		$uibModalInstance,
		jobs,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;

		/** @type {any} */
		this.histo = {};

		this.jobs = jobs;

		(async () => {
			await this.init();
		})();
	}

	close() {
		this.$uibModalInstance.close();
	}

	copyToClipboard() {
		let value = `"${this.$translate.instant('common.date')}"`;
		for (const job of this.jobs) {
			value += `;"${job.wf.name.replace('"', '\\"')}"`;
		}
		for (const [date, histo] of Object.entries(this.histo)) {
			value += `\r\n"${this.$filter('date')(date, 'short')}"`;
			for (const job of this.jobs) {
				value += `;"${histo[job.kid].name.replace('"', '\\"')}"`;
			}
		}

		this.$copyToClipboard(value, true);
	}

	/**
	 * @param {any} job
	 * @returns {string}
	 */
	getJobDescription(job) {
		return wfGetJobDescription(this.$injector, job);
	}

	async init() {
		for (const job of this.jobs) {
			const data = await APIV5.instance.wfAffectHisto({ wfaffect_kid: job.kid }, { id: 'modal-wf-history.init' });
			for (const histo of data.histo.map(h => wfMap(h))) {
				if (!(histo.sdate in this.histo)) {
					this.histo[histo.sdate] = {};
				}
				if (!(job.kid in this.histo[histo.sdate])) {
					this.histo[histo.sdate][job.kid] = [];
				}
				this.histo[histo.sdate][job.kid].push({
					...histo,
					name: wfGetJobDescription(this.$injector, histo),
				});
			}
		}

		this.histo = Object.keys(this.histo).sort((a, b) => {
			if (a < b) {
				return 1;
			}
			if (a > b) {
				return -1;
			}
			return 0;
			// eslint-disable-next-line unicorn/no-array-reduce
		}).reduce(
			(/** @type {any} */ job, /** @type {string} */ date) => {
				job[date] = this.histo[date];
				return job;
			},
			{},
		);

		this.$timeout(() => {
			this.$scope.$apply();
		});
	}
}
